/* eslint-disable max-lines-per-function */
import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    renderPrice, colors, filterObject, Title
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    },
    green: {
        backgroundColor: '#CCFFCC'
    },
    teal: {
        backgroundColor: '#B0E0E6'
    }
};

const IYCMatrix = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print portait'>
            <div>
                <Trigger />
            </div>

            <Title data={Object.values(filterObject(data, '1-'))} title='Intracoastal Yacht Club'/>
            <PrintDate isForPDF={false}/>
            <div className='print-font-small' >
                <Table celled compact textAlign='center'>

                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='100' content='BLDG 1' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='EAST'/>
                            <Table.HeaderCell content='01' />
                            <Table.HeaderCell content='03' />
                            <Table.HeaderCell content='05' />
                            <Table.HeaderCell content='07' />
                            <Table.HeaderCell content='09' />
                            <Table.HeaderCell content='11' />
                            <Table.HeaderCell content='15' />
                            <Table.HeaderCell content='17' />

                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='FLOORS'/>
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>

                        {
                            range(17, 3, -1)
                                .filter(num => num !== 13)
                                .map(n => n.toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                }))
                                .map((floor, i) => (
                                    <Table.Row key={`floor-${floor}`}>
                                        <Table.Cell content={floor} />
                                        {['01', '03', '05', '07', '09', '11', '15', '17'].map(unit_num => (
                                            <Table.Cell
                                                style={{ backgroundColor: colors[data[`1-${floor}${unit_num}`].status] }}
                                                content={renderPrice(data[`1-${floor}${unit_num}`], matrixType)}
                                            />
                                        ))}
                                    </Table.Row>
                                ))
                        }


                    </Table.Body>
                </Table>
                {/* <div className='pagebreak' /> */}
                {/* <Title title='Intracoastal Yacht Club'/> */}
                <Table celled compact textAlign='center'>

                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='100' content='West - BLDG 1 - Over Water & Marina' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='WEST'/>
                            <Table.HeaderCell content='02' />
                            <Table.HeaderCell content='04' />
                            <Table.HeaderCell content='06' />
                            <Table.HeaderCell content='08' />
                            <Table.HeaderCell content='10' />
                            <Table.HeaderCell content='12' />
                            <Table.HeaderCell content='14' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='FLOORS'/>
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='3 br / 2 ba' />

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>

                        {
                            range(17, 3, -1)
                                .filter(num => num !== 13)
                                .map(n => n.toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                }))
                                .map((floor, i) => (
                                    <Table.Row key={`floor-${floor}`}>
                                        <Table.Cell content={floor} />
                                        {['02', '04', '06', '08', '10', '12', '14'].map(unit_num => (
                                            <Table.Cell
                                                style={{ backgroundColor: colors[data[`1-${floor}${unit_num}`].status] }}
                                                content={renderPrice(data[`1-${floor}${unit_num}`], matrixType)}
                                            />
                                        ))}
                                    </Table.Row>
                                ))
                        }


                    </Table.Body>
                </Table>

            </div>

            <div className='pagebreak' />
            <div className='printspace' />
            <div className='print-font-small' >
                <Title data={Object.values(filterObject(data, '2-'))} title='Intracoastal Yacht Club'/>
                <PrintDate isForPDF={false}/>
                <Table celled compact textAlign='center'>

                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='100' content='West - BLDG 2 - Marina Side' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='NORTH'/>
                            <Table.HeaderCell content='02' />
                            <Table.HeaderCell content='04' />
                            <Table.HeaderCell content='06' />
                            <Table.HeaderCell content='08' />
                            <Table.HeaderCell content='10' />
                            <Table.HeaderCell content='12' />
                            <Table.HeaderCell content='14' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='FLOORS'/>
                            <Table.HeaderCell content='3 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>

                        {
                            range(25, 4, -1)
                                .filter(num => num !== 13)
                                .map(n => n.toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                }))
                                .map((floor, i) => (
                                    <Table.Row key={`floor-${floor}`}>
                                        <Table.Cell content={floor} />
                                        {['02', '04', '06', '08', '10', '12', '14'].map(unit_num => (
                                            <Table.Cell
                                                style={{ backgroundColor: colors[data[`2-${floor}${unit_num}`].status] }}
                                                content={renderPrice(data[`2-${floor}${unit_num}`], matrixType)} />
                                        ))}
                                    </Table.Row>
                                ))
                        }


                    </Table.Body>
                </Table>

                <Table celled compact textAlign='center'>

                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='100' content='West - BLDG 2 - Pool Side' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='SOUTH'/>
                            <Table.HeaderCell content='01' />
                            <Table.HeaderCell content='03' />
                            <Table.HeaderCell content='05' />
                            <Table.HeaderCell content='07' />
                            <Table.HeaderCell content='09' />
                            <Table.HeaderCell content='11' />
                            <Table.HeaderCell content='15' />
                            <Table.HeaderCell content='17' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='FLOORS'/>
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>

                        {
                            range(25, 4, -1)
                                .filter(num => num !== 13)
                                .map(n => n.toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                }))
                                .map((floor, i) => (
                                    <Table.Row key={`floor-${floor}`}>
                                        <Table.Cell content={floor} />
                                        {['01', '03', '05', '07', '09', '11', '15', '17'].map(unit_num => (
                                            <Table.Cell
                                                style={{ backgroundColor: colors[data[`2-${floor}${unit_num}`].status] }}
                                                content={renderPrice(data[`2-${floor}${unit_num}`], matrixType)}
                                            />
                                        ))}
                                    </Table.Row>
                                ))
                        }


                    </Table.Body>
                </Table>
            </div>
            <div className='pagebreak' />
            <div className='printspace' />
            <div className='print-font-small' >
                <Title data={Object.values(filterObject(data, '3-'))} title='Intracoastal Yacht Club'/>
                <PrintDate isForPDF={false}/>
                <Table celled compact textAlign='center'>

                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='100' content='West - BLDG 3 - Pool Side' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='NORTH'/>
                            <Table.HeaderCell content='01' />
                            <Table.HeaderCell content='03' />
                            <Table.HeaderCell content='05' />
                            <Table.HeaderCell content='07' />
                            <Table.HeaderCell content='09' />
                            <Table.HeaderCell content='11' />
                            <Table.HeaderCell content='15' />
                            <Table.HeaderCell content='17' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='FLOORS'/>
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>

                        {
                            range(25, 4, -1)
                                .filter(num => num !== 13)
                                .map(n => n.toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                }))
                                .map((floor, i) => (
                                    <Table.Row key={`floor-${floor}`}>
                                        <Table.Cell content={floor} />
                                        {['01', '03', '05', '07', '09', '11', '15', '17'].map(unit_num => (
                                            <Table.Cell
                                                style={{ backgroundColor: colors[data[`3-${floor}${unit_num}`].status] }}
                                                content={renderPrice(data[`3-${floor}${unit_num}`], matrixType)}
                                            />
                                        ))}
                                    </Table.Row>
                                ))
                        }


                    </Table.Body>
                </Table>

                <Table celled compact textAlign='center'>

                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan='100' content='West - BLDG 3 - Downtown Side' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='SOUTH'/>
                            <Table.HeaderCell content='02' />
                            <Table.HeaderCell content='04' />
                            <Table.HeaderCell content='06' />
                            <Table.HeaderCell content='08' />
                            <Table.HeaderCell content='10' />
                            <Table.HeaderCell content='12' />
                            <Table.HeaderCell content='14' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell content='FLOORS'/>
                            <Table.HeaderCell content='3 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='2 br / 2 ba' />
                            <Table.HeaderCell content='1 br / 1 ba' />

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>

                        {
                            range(25, 4, -1)
                                .filter(num => num !== 13)
                                .map(n => n.toLocaleString('en-US', {
                                    minimumIntegerDigits: 2,
                                    useGrouping: false
                                }))
                                .map((floor, i) => (
                                    <Table.Row key={`floor-${floor}`}>
                                        <Table.Cell content={floor} />
                                        {['02', '04', '06', '08', '10', '12', '14'].map(unit_num => (
                                            <Table.Cell
                                                style={{ backgroundColor: colors[data[`3-${floor}${unit_num}`].status] }}
                                                content={renderPrice(data[`3-${floor}${unit_num}`], matrixType)}
                                            />
                                        ))}
                                    </Table.Row>
                                ))
                        }


                    </Table.Body>
                </Table>

            </div>
        </div>
    );


};

export default IYCMatrix;
